import { Loader } from '@comall-backend-builder/core/lib/loaders';
import { ApiRequestConfig, api } from '@comall-backend-builder/core/lib/services/api';

// 直播banner
export const LiveListLoader: Loader = {
    // 直播banner列表
    get: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = '/live/banner';
        const response: any = await api.get(params, config);
        return response;
    },

    // 新增直播banner
    post: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = '/live/banner/add';
        const response: any = await api.post(params, config);
        return response;
    },
    // 修改直播banner
    put: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = '/live/banner/upd';
        const response: any = await api.post(params, config);
        return response;
    },
    // 删除直播banner
    delete: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = `/live/banner/del/${params.id}`;
        const response: any = await api.post(params, config);
        return response;
    },
};
